import { ProductType } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSigned } from './fetchFromApi';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchProductType = (productTypeId: string, contextId = getParams().contextId) =>
  getParams().useGlobalInventoryData
    ? fetchFromApiSigned<ProductType>(`productTypes/${productTypeId}`, { allPrintTypes: true })
    : fetchFromDesignerService<ProductType>(`assortment/${productTypeId}`, { shopId: contextId });
